import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-stack",
  "use": "icon-stack-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-stack\"><g fill=\"currentColor\"><path d=\"M11.995 4L3.51 8.485l8.485 4.486 8.486-4.486L11.995 4zm.935-1.768l8.485 4.485c1.42.751 1.42 2.786 0 3.536L12.93 14.74a2 2 0 0 1-1.87 0l-8.485-4.486c-1.42-.75-1.42-2.785 0-3.536l8.486-4.485a2 2 0 0 1 1.869 0z\" /><path d=\"M2.966 12.115a1 1 0 1 0-.932 1.77l9.5 5a1 1 0 0 0 .932 0l9.5-5a1 1 0 1 0-.932-1.77L12 16.87l-9.034-4.755z\" /><path d=\"M2.966 16.115a1 1 0 1 0-.932 1.77l9.5 5a1 1 0 0 0 .932 0l9.5-5a1 1 0 1 0-.932-1.77L12 20.87l-9.034-4.755z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-stack.svg
// module id = 889
// module chunks = 74